<template>

    <div class="equipment-view-compliance-exemptions">
        <b-table-simple class="table-responsive no-border previous-exemptions mt-4 mb-3"
                        v-if="exemptions.length">
            <b-thead head-variant="dark" class="previous-exemptions__heading">
                <b-tr>
                    <b-th colspan="4">
                        Previous Exemption Requests
                    </b-th>
                </b-tr>
            </b-thead>
            <b-thead head-variant="light" class="previous-exemptions__headers">
                <b-tr>
                    <b-th>Created</b-th>
                    <b-th>Expiration</b-th>
                    <b-th>Status</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="exemption in equipment.exemptions" :key="exemption.id">
                    <b-td>
                        <timestamp :date="exemption.created"/>
                    </b-td>
                    <b-td>
                        <timestamp :date="exemption.expiration"/>
                    </b-td>
                    <b-td class="text-center">
                        <exemption-status-badge :status="exemption.status"
                                                :granted-thru="exemption.granted_thru"/>
                    </b-td>
                    <b-td>
                        <b-btn size="sm" variant="primary" class="m-2"
                               v-if="canEditExemption(exemption)"
                               @click="editExemption(exemption)">
                            Edit
                            <b-icon-pencil-square/>
                        </b-btn>
                        <b-btn size="sm" variant="danger" class="m-2"
                               v-if="canDeleteExemption(exemption)"
                               @click="deleteExemption(exemption)">
                            <b-icon-trash/>
                        </b-btn>
                        <auth-template model="exemption" action="approve" :arg="exemption.id">
                            <b-btn size="sm" class="m-2"
                                   :to="`/exemption/view/${exemption.id}`">
                                <b-icon-eye/>
                            </b-btn>
                        </auth-template>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <b-btn variant="success" class="float-right"
               v-if="canCreateExemption"
               @click="createExemption()">
            Create new Exemption Request
            <b-icon-plus-square/>
        </b-btn>
    </div>

</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'

/**
 * List of previous/current exemption requests for an Equipment, with action buttons
 */

export default Vue.extend({
    name: 'EquipmentViewComplianceExemptions',
    props: {
        equipment: Object,
        // NB: this just means that the exemption option is selected - more restrictions apply for editing, etc.
        canCreate: Boolean
    },
    computed: {
        exemptions () {
            return this.equipment.exemptions
        },
        canCreateExemption () {
            return this.$user.isEquipmentOwner() && this.canCreate && !this.hasOutstandingExemptions()
        },
    },
    methods: {
        createExemption () {
            this.$router.push(`/exemption/create/${this.equipment.id}`)
        },
        canEditExemption (exemption) {
            return this.$user.isEquipmentOwner() && this.isOutstandingExemption(exemption)
        },
        editExemption (exemption) {
            this.$router.push(`/exemption/edit/${exemption.id}`)
        },
        canDeleteExemption (exemption) {
            return this.$user.isEquipmentOwner() && this.isOutstandingExemption(exemption)
        },
        async deleteExemption (exemption) {
            await this.$api.deleteItem(this, 'exemption', exemption)
            this.$emit('updated')
        },
        hasOutstandingExemptions () {
            return _.some(this.exemptions, (exemption) => {
                return this.isOutstandingExemption(exemption)
            })
        },
        isOutstandingExemption (exemption) {
            return exemption.status === 'DRAFT' || exemption.status === 'PENDING' // PENDING = submitted
        }
    },
})
</script>

<style lang="scss">
    .previous-exemptions__heading {
        border: solid 1px var(--black);
    }

    .previous-exemptions__headers {
        border: solid 1px #e9ecef;
    }

    .previous-exemptions tbody {
        tr {
            &:last-child td {
                border-bottom: solid 1px #e9ecef;
            }
        }

        td {
            border-left: solid 1px #e9ecef;
            border-right: solid 1px #e9ecef;
        }
    }
</style>